import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '../home/home.component';
import { NoAccessComponent, PageNotFoundComponent } from '../shared';

import { AuthGuard, MustBeAdminGuardService, MustBeLoggedInGuardService, HasAccessGuard, CustomPreloader } from '../core';

const appRoutes: Routes = [
  { path: HomeComponent.route, component: HomeComponent, pathMatch: 'full', data: { title: "PageTitle.Home" }  },
  //{ path: '', redirectTo: HomeComponent.route, pathMatch: 'full' },//not use, because PageNotFound

  //Lazy Loading Reports Modules
  //Note: keep path in sync with sidebar
  //      keep loadChildren in sync with module's file location
  {
    path: 'dashboard', loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.Dashboard", preload: true }
  },
  {
    path: 'baskets', loadChildren: () => import('../pages/baskets/baskets.module').then(m => m.BasketsModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.Baskets", preload: true }
  },
  {
    path: 'find-vehicles', loadChildren: () => import('../pages/vehicles/vehicles.module').then(m => m.VehiclesModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.FindVehicle", preload: true }
  },
  {
    path: 'related', loadChildren: () => import('../pages/related/related.module').then(m => m.RelatedModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.FindVehicle", preload: true }
  },
  {
    path: 'reports', loadChildren: () => import('../pages/reports/reports.module').then(m => m.ReportsModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard, HasAccessGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.Reports", preload: true }
  },
  {
    path: 'admin', loadChildren: () => import('../pages/admin/admin.module').then(m => m.AdminModule),
    /*canLoad: [AuthGuard, HasAccessGuard],*/ canActivate: [AuthGuard], canActivateChild: [AuthGuard], data: { title: "PageTitle.Admin", preload: false }
  },

  { // hidden for test purposes
    path: 'charts', loadChildren: () => import('../pages/charts/charts.module').then(m => m.ChartsModule), data: { title: "PageTitle.Charts", preload: true }
  },

  //{ path: 'unauthorised', component: UnauthorisedComponent },
  { path: NoAccessComponent.route, component: NoAccessComponent },

  { path: 'privacyNotice', 
  loadChildren: () => import('../pages/privacynotice/privacynotice.module').then(m => m.PrivacyNoticeModule), data: { title: "Pagetitle.privacyNotice", preload: true }
  },

  //Note: keep it last ( no default view )
  { path: PageNotFoundComponent.route/*  '**'  */, component: PageNotFoundComponent, data: { title: "PageTitle.PageNotFound" } },
];

@NgModule({
  imports: [
    RouterModule,
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: CustomPreloader,
      //onSameUrlNavigation: 'reload'
      //relativeLinkResolution: 'corrected'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }

export const routableComponents = [
  HomeComponent,
  //Lazy Loaded
];
